import { render, staticRenderFns } from "./EditerTemplate.vue?vue&type=template&id=422a5d13&scoped=true&"
import script from "./EditerTemplate.vue?vue&type=script&lang=js&"
export * from "./EditerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditerTemplate.vue?vue&type=style&index=0&id=422a5d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a5d13",
  null
  
)

export default component.exports